import React from "react"
import { Table, Badge, Card, CardHeader } from "reactstrap"
import { getSportsConfig } from "../../../utility/constants/sportConfig"
import styles from "../Players.module.scss"

function SpectatePlayersTable({ homeTeam, awayTeam }) {
	const { hasBench } = getSportsConfig(localStorage.getItem("sport"))

	const createPlayer = (player, isAwayTeam, hideTShirtNumber) => {
		if (!player) return <td></td>

		const { tshirtNumber, name, surname, playerId } = player
		return (
			<td
				style={{ textAlign: "start", direction: isAwayTeam ? "rtl" : "ltr" }}
			>
				{!hideTShirtNumber && `${tshirtNumber} - `}
				{`${name} ${surname}`}
				{playerId === homeTeam.captainId && (
					<Badge pill color="light-primary" className="mr-1">
						Kapetan
					</Badge>
				)}
			</td>
		)
	}

	const createTable = (title, error, homeTeam, awayTeam, isNedostaje) => {
		const maxLength = Math.max(homeTeam.length, awayTeam.length)
		const rows = []
		for (let i = 0; i < maxLength; i++) {
			rows.push(
				<tr key={`playerRow-${i}`}>
					{createPlayer(homeTeam[i], false, isNedostaje)}
					{createPlayer(awayTeam[i], true, isNedostaje)}
				</tr>
			)
		}
		if (rows.length == 0 && isNedostaje) return <></>
		return (
			<>
				<Table responsive>
					<thead>
						<tr>
							<th style={{ textAlign: "center" }}>{title}</th>
						</tr>
					</thead>
				</Table>
				{maxLength ? (
					<Table responsive>
						<tbody>{rows}</tbody>
					</Table>
				) : (
					<p style={{ textAlign: "center", marginTop: "1em" }}>{error}</p>
				)}
			</>
		)
	}

	return (
		<Card>
			<CardHeader>
				<h1>Igrači</h1>
			</CardHeader>
			<div className={styles.teamName}>
				<h3>{homeTeam.name}</h3>
				<h3>{awayTeam.name}</h3>
			</div>
			{createTable(
				"Prve postave",
				"Nema prve postave",
				homeTeam?.players?.filter(
					(elem) =>
						elem.position?.toLowerCase() != "bench" &&
						elem.position?.toLowerCase() != "bench-gk" &&
						elem.position?.toLowerCase() != "nedostaje"
				) ?? [],
				awayTeam?.players?.filter(
					(elem) =>
						elem.position?.toLowerCase() != "bench" &&
						elem.position?.toLowerCase() != "bench-gk" &&
						elem.position?.toLowerCase() != "nedostaje"
				) ?? []
			)}
			{hasBench && (
				<>
					{createTable(
						"Zamjene",
						"Nema zamjene",
						homeTeam?.players?.filter(
							(elem) =>
								elem.position?.toLowerCase() == "bench" ||
								elem.position?.toLowerCase() == "bench-gk"
						) ?? [],
						awayTeam?.players?.filter(
							(elem) =>
								elem.position?.toLowerCase() == "bench" ||
								elem.position?.toLowerCase() == "bench-gk"
						) ?? []
					)}
					{createTable(
						"Nedostaju",
						"Nema igrača koji nedostaju",
						homeTeam?.players?.filter(
							(elem) => elem.position?.toLowerCase() == "nedostaje"
						) ?? [],
						awayTeam?.players?.filter(
							(elem) => elem.position?.toLowerCase() == "nedostaje"
						) ?? [],
						true
					)}
				</>
			)}
		</Card>
	)
}

export default SpectatePlayersTable
